import axios from '@/libs/axios'

export class DrainagePlanService {


  static async getPlanById(id) {
    return new Promise((resolve, reject) => {
      axios.get(`plans/${id}`)
        .then(res => resolve(res.data.plan))
        .catch(reason => reject(reason.response))
    })
  }


  static async createPlan(data) {
    return new Promise((resolve, reject) => {
      axios.post(`plans`, data)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }


  static async updatePlan(id, data) {
    return new Promise((resolve, reject) => {
      axios.put(`plans/${id}`, data)
        .then(res => resolve(res.data.device))
        .catch(reason => reject(reason.response))
    })
  }



  static async deletePlan(id,PlanType) {
    return new Promise((resolve, reject) => {
      axios.delete(`plans/${id}?type=${PlanType}`)
        .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
  }

}
